import React, { useState, useEffect, useRef } from "react";
import { Button, Col, Row } from "reactstrap";
import { useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import { useDispatch, useSelector } from "react-redux";
import {
  addCartDetails,
  clearCartAction,
  clearCartDetails,
} from "../../store/actions/cartAction";

const MenuCategories = ({ categories, isHoliday }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const { cartDetails } = useSelector((state) => state.cart);
  const color = useSelector((state) => state.global.color);
  const { restaurantsDetail } = useSelector((state) => state.restaurants);
  const [loadingCategory, setLoadingCategory] = useState(null);
  const isMountedRef = useRef(true);
  const timeoutRefs = useRef([]);

  useEffect(() => {
    return () => {
      isMountedRef.current = false;
      // Clear all timeouts on unmount
      timeoutRefs.current.forEach(clearTimeout);
    };
  }, []);

  const handleCategoryClick = async (categoryId) => {
    if (isHoliday?.isHoliday || isHoliday?.storeTiming) {
      const typeLabel =
        isHoliday?.type === "dinein"
          ? "Dine-in"
          : isHoliday?.type === "delivery"
          ? "Delivery"
          : "Takeaway";

      const typeIcon =
        isHoliday?.type === "dinein"
          ? "🍽️"
          : isHoliday?.type === "delivery"
          ? "🚚"
          : "🛍️";

      toast.warning(
        isHoliday?.isHoliday
          ? `📅 Attention: The ${restaurantsDetail?.name} store is closed today due to ${isHoliday?.title}. Please check back tomorrow.`
          : `${typeIcon} Notice: ${typeLabel} service is currently unavailable as operating hours have ended. Please select a different option or check back tomorrow.`,
        {
          position: "top-center",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          style: {
            backgroundColor: "#fff3cd",
            color: "#856404",
            fontWeight: "500",
            fontSize: "15px",
          },
        }
      );

      if (!isMountedRef.current) return;
      setLoadingCategory(categoryId);
      const timeoutId = setTimeout(() => {
        if (isHoliday?.storeTiming) {
          history.push("/order-options");
        } else if (isHoliday?.isHoliday) {
          history.push("/restaurants");
          dispatch(clearCartAction());
          dispatch(clearCartDetails());
        }
        if (isMountedRef.current) {
          setLoadingCategory(null);
        }
      }, 1500);
      timeoutRefs.current.push(timeoutId);
      return;
    }
    if (!isMountedRef.current) return;
    setLoadingCategory(categoryId);
    const existingCart = cartDetails || {};
    const updatedCart = {
      ...existingCart,
      menuId: categoryId,
    };
    dispatch(addCartDetails(updatedCart));
    try {
      await new Promise((resolve) => setTimeout(resolve, 800));
      if (!isMountedRef.current) return;
      history.push(`/restaurant-details/${categoryId}`);
    } finally {
      const timeoutId = setTimeout(() => {
        if (isMountedRef.current) {
          setLoadingCategory(null);
        }
      }, 1500);
      timeoutRefs.current.push(timeoutId);
    }
  };

  return (
    <Row className="justify-content-center pb-4">
      <Col
        xs="12"
        md="8"
        lg="6"
        className="d-flex flex-column align-items-center"
      >
        {categories && categories?.length > 0 ? (
          categories.map((category, index) => (
            <div key={index} className="w-100 d-flex justify-content-center">
              <Button
                onClick={() => handleCategoryClick(category?.id)}
                className="mb-3 restaurant__profile__button text-truncate px-2"
                style={{
                  background: color,
                  maxWidth: "450px",
                  width: "100%",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
                disabled={loadingCategory === category.id}
              >
                Go to {category.name}
              </Button>
            </div>
          ))
        ) : (
          <h6 className="text-capitalize restaurant__profile__name text-center">
            No Menu Exists in this Restaurant
          </h6>
        )}
      </Col>
    </Row>
  );
};

export default MenuCategories;
